// extracted by mini-css-extract-plugin
export default {"openAICommonContainer":"OpenAICommon_openAICommonContainer__Q217j","title":"OpenAICommon_title__laDyD","label":"OpenAICommon_label__4xT0P"};